import React from 'react';
import { Icon } from 'antd';

import AppContext from '@services/Context';
import I18n from '../../../../i18n';
import { TicketStatus } from '@interfaces/ticket-status';
import styled from 'styled-components';
import { Theme } from '../../../../styled-components';

interface IProp {
    status: TicketStatus
    statusLabel?: string
}

class WorkflowStatusComponent extends React.Component<IProp, {}> {

    getInProgressStatus(hasStatusLabel: boolean, locale: any) {
        if (hasStatusLabel) {
            return (
                <h3 className="goepik-status-in-progress">
                    <Icon type="clock-circle" />
                    {I18n.l('common.status')} "{this.props.statusLabel}"
                </h3>
            )
        } else {
            return (
                <h3 className="goepik-status-in-progress">
                    <Icon type="clock-circle" />
                    {I18n.l('common.status')} "{I18n.l('global.ticket.status.inprogress')}"
                </h3>
            )
        }
    }

    render(): JSX.Element {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <GoEpikWorkflowItemStatus>
                        <div className="goepik-history-status">
                            {
                                (this.props.status == TicketStatus.IN_PROGRESS)
                                &&
                                this.getInProgressStatus(this.props.statusLabel != null || this.props.statusLabel != undefined, locale)
                            }
                            {
                                (this.props.status == TicketStatus.CLOSED)
                                &&
                                <h3 className="goepik-status-done">
                                    <Icon type="check-circle" />
                                    {I18n.l('common.status')} "{I18n.l('global.ticket.status.done')}"
                            </h3>
                            }
                            {
                                (this.props.status == TicketStatus.CANCELED)
                                &&
                                <h3 className="goepik-status-error">
                                    <Icon type="close-circle" />
                                    {I18n.l('common.status')} "{I18n.l('global.ticket.status.error')}"
                            </h3>
                            }
                        </div>
                    </GoEpikWorkflowItemStatus>
                )}
            </AppContext.Consumer>
        );
    }
};

const GoEpikWorkflowItemStatus = styled.div`
    .goepik-history-status{
        .anticon{
            padding-right: 6px;
        }

        .goepik-status-in-progress{
            color: ${Theme.status.inProgress};
        }

        .goepik-status-done{
            color: ${Theme.status.done || '#28DCAA'};
        }

        .goepik-status-error{
            color: ${Theme.status.error};
        }
    }
`;

export default WorkflowStatusComponent;
